/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { mobileOrderDailyStatsItemSchema } from "./mobileOrderDailyStatsItemSchema.ts";

export const mobileOrderDailyStatsResponseSchema = z.object({
	results: z.array(mobileOrderDailyStatsItemSchema),
});
